import { render, staticRenderFns } from "./SearchResultTable.vue?vue&type=template&id=61d9a68b&scoped=true"
import script from "./SearchResultTable.vue?vue&type=script&lang=js"
export * from "./SearchResultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d9a68b",
  null
  
)

export default component.exports